import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IInspectionItem } from 'app/shared/model/inspection-item.model';
import { getEntities as getInspectionItems } from 'app/entities/inspection-item/inspection-item.reducer';
import { IInspectionHistory } from 'app/shared/model/inspection-history.model';
import { getEntities as getInspectionHistories } from 'app/entities/inspection-history/inspection-history.reducer';
import { getEntity, updateEntity, createEntity, reset } from './inspection-item-performed.reducer';
import { IInspectionItemPerformed } from 'app/shared/model/inspection-item-performed.model';
import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const InspectionItemPerformedUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const inspectionItems = useAppSelector(state => state.inspectionItem.entities);
  const inspectionHistories = useAppSelector(state => state.inspectionHistory.entities);
  const inspectionItemPerformedEntity = useAppSelector(state => state.inspectionItemPerformed.entity);
  const loading = useAppSelector(state => state.inspectionItemPerformed.loading);
  const updating = useAppSelector(state => state.inspectionItemPerformed.updating);
  const updateSuccess = useAppSelector(state => state.inspectionItemPerformed.updateSuccess);

  const handleClose = () => {
    props.history.push('/inspection-item-performed' + props.location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }

    dispatch(getInspectionItems({}));
    dispatch(getInspectionHistories({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...inspectionItemPerformedEntity,
      ...values,
      inspectionItem: inspectionItems.find(it => it.id.toString() === values.inspectionItemId.toString()),
      inspectionHistory: inspectionHistories.find(it => it.id.toString() === values.inspectionHistoryId.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...inspectionItemPerformedEntity,
          inspectionItemId: inspectionItemPerformedEntity?.inspectionItem?.id,
          inspectionHistoryId: inspectionItemPerformedEntity?.inspectionHistory?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fleetSenseApp.inspectionItemPerformed.home.createOrEditLabel" data-cy="InspectionItemPerformedCreateUpdateHeading">
            <Translate contentKey="fleetSenseApp.inspectionItemPerformed.home.createOrEditLabel">Create or edit a InspectionItemPerformed</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="inspection-item-performed-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fleetSenseApp.inspectionItemPerformed.satisfied')}
                id="inspection-item-performed-satisfied"
                name="satisfied"
                data-cy="satisfied"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('fleetSenseApp.inspectionItemPerformed.observations')}
                id="inspection-item-performed-observations"
                name="observations"
                data-cy="observations"
                type="text"
              />
              <ValidatedBlobField
                label={translate('fleetSenseApp.inspectionItemPerformed.image')}
                id="inspection-item-performed-image"
                name="image"
                data-cy="image"
                isImage
                accept="image/*"
              />
              <ValidatedField
                id="inspection-item-performed-inspectionItem"
                name="inspectionItemId"
                data-cy="inspectionItem"
                label={translate('fleetSenseApp.inspectionItemPerformed.inspectionItem')}
                type="select"
              >
                <option value="" key="0" />
                {inspectionItems
                  ? inspectionItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="inspection-item-performed-inspectionHistory"
                name="inspectionHistoryId"
                data-cy="inspectionHistory"
                label={translate('fleetSenseApp.inspectionItemPerformed.inspectionHistory')}
                type="select"
              >
                <option value="" key="0" />
                {inspectionHistories
                  ? inspectionHistories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/inspection-item-performed" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default InspectionItemPerformedUpdate;
